'use strict';

angular.module('openDataApp')
  .controller('ApplicationFormCtrl', ['$scope', '$q', '$location', '$timeout', 'moment', 'ApiService', 'AuthService', function ($scope, $q, $location, $timeout, Moment, ApiService, AuthService) {

    $scope.kvk = {};
    $scope.formData = { months: 1 };
    $scope.greatSuccess = false;
    $scope.freePlan = true;
    $scope.showEmergencyPlans = false;
    $scope.totalAmount = 0;
    $scope.remainingDaysAmount = 0;
    $scope.totalDiscount = 0;
    $scope.today = new Date();
    $scope.planCost = 0;
    $scope.planCostPerDay = 0;
    $scope.startDate = new Moment();
    $scope.endDate = ($scope.startDate.date() === 1 ? new Moment().add($scope.formData.months, 'months').subtract(1, 'day') : new Moment().add($scope.formData.months, 'months').endOf('month'));
    $scope.remainingDays = ($scope.startDate.date() === 1 ? 0 : new Moment().endOf('month').diff($scope.startDate, 'days') + 1);
    $scope.timespan = { length: 1 };

    $scope.changeTimespan = function(timespan) {
      $scope.formData.months = timespan.length;
      $scope.timespan = timespan;
      $scope.totalAmount = $scope.remainingDaysAmount + (($scope.timespan.length - ($scope.timespan.freeMonths !== undefined ? $scope.timespan.freeMonths : 0)) * $scope.planCost);
      $scope.totalDiscount = (timespan.freeMonths !== undefined ? timespan.freeMonths : 0) * $scope.planCost;
      $scope.endDate = ($scope.startDate.date() === 1 ? new Moment().add($scope.formData.months, 'months').subtract(1, 'day') : new Moment().add($scope.formData.months, 'months').endOf('month'));
      return false;
    };

    $scope.changePlan = function(plan) {
      $scope.formData.plan = plan;
      $scope.planCost = $scope.staticData.plans.normal[plan].price;
      $scope.planCostPerDay = $scope.staticData.plans.normal[plan].price / 30;

      if ($scope.planCost === '0') {
        $scope.freePlan = true;
      } else {
        $scope.freePlan = false;
        $scope.remainingDaysAmount = Math.round(($scope.remainingDays * $scope.planCostPerDay) * 100) / 100;
        $scope.totalAmount = $scope.remainingDaysAmount + (($scope.timespan.length - ($scope.timespan.freeMonths !== undefined ? $scope.timespan.freeMonths : 0)) * $scope.planCost);
        $scope.totalDiscount = ($scope.timespan.freeMonths !== undefined ? $scope.timespan.freeMonths : 0) * $scope.planCost;
      }
      return false;
    };

    $scope.submit = function(formData) {
      if (!$scope.greatSucces) {
        $scope.submitting = true;
        $scope.applicationFormSubmitError = null;

        var def = $q.defer();

        var hasPaidPlan = $scope.staticData.plans.normal[formData.plan] !== undefined && $scope.staticData.plans.normal[formData.plan].price > 0;

        ApiService.newAccount(formData, hasPaidPlan)
          .then(
            function success(response) {
              $scope.greatSuccess = true;

              if (hasPaidPlan) {
                $scope.applicationFormNextStep = '<p>Je account is succesvol aangemaakt.</p><p>We sturen je nu door naar de betalingspagina.</p>';
                $timeout(function () {
                  window.location.href = response.data.response;
                }, 2000);
              } else {
                $scope.applicationFormNextStep = '<p>Je account is succesvol aangemaakt.</p><p><a href="https://' + ($scope.currentService.subdomain || 'opendata') + ($scope.currentService.subdomain ? '.' : '') + ($scope.standardSubdomain || '') + ($scope.standardSubdomain ? '.' : '') + $scope.host + '/dashboard" class="button">Klik hier om naar je account te gaan</a></p>';
                AuthService.loginAfterRegistration(response.data.response);
              }

              def.resolve();
            },
            function error(response) {
              $scope.submitting = false;
              $scope.applicationFormSubmitError = response.data.error !== undefined ? response.data.error : 'Er is iets misgegaan, probeer het later nog eens.';
              def.reject();
            }
          );

        return def.promise;
      }
    };
  }]);
